class BisPhoneInput {
  constructor(input) {
    this.input = input;
    this.instance = window.intlTelInput(input, {
      countryNameLocale: document.documentElement.lang || 'en',
      countrySearch: true,
      formatAsYouType: true,
      initialCountry: this.getInitialCountry(),
      separateDialCode: true,
      strictMode: true,
    });
  }

  getInitialCountry() {
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
    const region = languages
      .map((language) => language?.split('-')[1])
      .find(Boolean);

    return region && /^[a-z]{2}$/i.test(region) ? region.toLowerCase() : 'us';
  }

  async getE164() {
    if (!this.input.value.trim()) {
      return { error: 'required' };
    }

    await this.instance.promise;

    if (!this.instance.isValidNumber()) {
      return { error: 'invalid' };
    }

    return { e164: this.instance.getNumber() };
  }
}

window.BisPhoneInput = BisPhoneInput;
window.dispatchEvent(new Event('bis-phone-input-ready'));
